import { useTranslation } from "react-i18next";

import { toInitUpperCase } from "utility";
import { parsePaymentMethod } from "utility/paymentMethod";

import { PaymentMethodCard } from "components/common/paymentMethodCard/PaymentMethodCard";

import { updateSlide } from "store/common/common-slice";
import { PaymentMethod } from "store/paymentMethods/paymentMethods-state";
import { selectAllPaymentMethods } from "store/paymentMethods/paymentMethods-slice";
import { useRootDispatch, useRootSelector } from "store/hooks";
import { selectAutoPay } from "store/payments/payments-slice";

import classes from "./PaymentMethods.module.scss";
import {
  getAccountRestrictions,
  selectedAccountInfo,
} from "store/account/account-selector";
import { useMemo } from "react";

export const PaymentMethods = () => {
  const dispatch = useRootDispatch();
  const { t } = useTranslation(["common", "payment_next"]);
  const clickHandler = () => {
    dispatch(updateSlide({ id: "AddPaymentMethods" }));
  };

  const paymentMethods = useRootSelector(selectAllPaymentMethods);
  const accountInfo = useRootSelector(selectedAccountInfo);
  const { restrictions } = useRootSelector(getAccountRestrictions);

  const actionDisabled: boolean = useMemo(() => {
    return (
      accountInfo?.active !== true ||
      (restrictions.achRestricted && restrictions.cardRestricted)
    );
  }, [accountInfo, restrictions]);

  const { meta } = useRootSelector((state) => state.paymentMethods);

  const autoPayInfo = useRootSelector(selectAutoPay);

  const autoPayMethods = autoPayInfo
    ?.filter((p) => p.status === 1)
    .map((p) => p.paymentMethodId);

  const renderPaymentMethods = (methods: PaymentMethod[]) => {
    return methods.map((single, index) => {
      const { title, detailLine } = parsePaymentMethod(single);
      return (
        <PaymentMethodCard
          data={single}
          key={index}
          title={toInitUpperCase(title)}
          detail={detailLine}
          type={single.paymentMethodType}
          expiryDate={single.expirationDate ? single.expirationDate : ""}
          autoPay={autoPayMethods?.includes(single.id!) ? true : false}
        />
      );
    });
  };

  return (
    <section className={classes.Container}>
      {meta.isLoading ? <ft-screen-loader></ft-screen-loader> : null}
      <div className={classes.PaymentMethodsContainer}>
        {paymentMethods ? renderPaymentMethods(paymentMethods) : null}
      </div>
      <ft-divider></ft-divider>
      <ft-button
        data-testid="payment-method-add-payment-btn"
        class={classes.Create}
        label={t("common:add_payment_method", {
          value: "+",
        })}
        unelevated
        disabled={actionDisabled ? actionDisabled : null}
        onClick={clickHandler}
      ></ft-button>
    </section>
  );
};
